var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 4C9.372 4 4 9.405 4 16.073 4 22.1 8.387 27.095 14.125 28v-8.437h-3.047v-3.49h3.047v-2.66c0-3.025 1.79-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H19.83c-1.491 0-1.955.931-1.955 1.886v2.264h3.328l-.532 3.49h-2.796V28C23.613 27.095 28 22.1 28 16.073 28 9.405 22.628 4 16 4"
})));
export default SvgFacebook;